export default "__VITE_ASSET__Dww1tbJ$__"